import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImageCropperDialogComponent } from 'src/app/components/shared-components/image-cropper-dialog/image-cropper-dialog.component';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';
import { DepartmentsHelpbuttonService } from '../../../services/helpbutton-services/departments-helpbutton-service/departments-helpbutton.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from '../../shared-components/spinner/spinner.service';


@Component({
  selector: 'app-helpbutton-department-photo-editor-card',
  templateUrl: './helpbutton-department-photo-editor-card.component.html',
  styleUrls: ['./helpbutton-department-photo-editor-card.component.scss']
})
export class HelpbuttonDepartmentPhotoEditorCardComponent implements OnInit {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  @Input() departmentInfo;
  showSpinner: boolean;

  constructor(private snackbarService: SnackBarService,
    private departmentService: DepartmentsHelpbuttonService,
    private validationImageService: ValidationImageService,
    private spinnerService: SpinnerService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.showSpinner = false;
  }

  public uploadPhotoClicker() {
    this.uploadInput.nativeElement.value = null;
    this.uploadInput.nativeElement.click();
  }

  public uploadAsset(event) {
    const file = event.target.files[0];
    const img = new Image();
    this.validationImageService.toBase64(file).subscribe(
      (base64) => {
        const dialogRef = this.dialog.open(ImageCropperDialogComponent, {
          data: { image: base64, width: 720, height: 300 }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.departmentInfo.sectionImage = result;
            this.showSpinner = true;
            this.spinnerService.show('department-photo-editor-spinner');
            this.departmentService.updateImageDepartment(this.departmentInfo.InternalId, result).subscribe(
              (res) => {
                this.departmentService.refreshDepartment();
                this.showSpinner = false;
                this.spinnerService.hide('department-photo-editor-spinner');
              },
              (error) => {
                this.departmentService.refreshDepartment();
                this.showSpinner = false;
                this.spinnerService.hide('department-photo-editor-spinner');
                this.snackbarService.open(error['error']['message'], 'error');
              }
            );
          }
        });
      },
      (error) => {
        this.departmentService.refreshDepartment();
        this.snackbarService.open(error, 'error');
      }
    );
  }

}
